import React from "react";
import { Form, Icon } from "semantic-ui-react";
import { useFormContext } from "react-hook-form";

// Helpers
import { confirmationList } from "@common/components/helpers/options/ageVerificationSelect";
import { getCurrentDateTime } from "@common/components/helpers/datetime";
import { useWindowWidth } from "@common/components/helpers/useWindowWidth";
import { under18List } from "@common/components/helpers/options/ageVerificationSelect";

// Components
import SelectComponent from "@common/components/shared/forms/SelectComponent";
import TextareaComponent from "@common/components/shared/forms/TextareaComponent";
import DateComponent from "@common/components/shared/forms/DateComponent";
import CheckboxComponent from "@common/components/shared/forms/CheckboxComponent";
import useLogin from "../../hooks/useLogin.js";

const CustomerHasIdForm = ({ idTypes, genders, idOther }) => {
  const {
    control,
    register,
    watch,
    formState: { errors },
  } = useFormContext();

  const width = useWindowWidth();
  const [{ isDesktop, isInReadMode }] = useLogin();

  const watchUnder18 = watch("under18");

  return (
    <>
      <SelectComponent
        name="idType"
        label="ID Type"
        placeholder="Select type of ID"
        control={control}
        error={errors.idType}
        options={idTypes}
      />
      {idOther && (
        <TextareaComponent
          name="otherId"
          label=" "
          placeholder="Please describe ID provided"
          register={register}
          error={errors.otherId}
        />
      )}
      <SelectComponent
        name="gender"
        label="Gender"
        placeholder="Select gender"
        control={control}
        error={errors.gender}
        options={genders}
        selectContainerStyle={width > 700 ? "w-50" : ""}
      />

      <DateComponent
        control={control}
        name="dateOfBirth"
        label="Date of Birth"
        dateFormat="YYYY-MM-DD"
        maxDate={getCurrentDateTime()}
        startMode="year"
        initialDate="1992-01-01"
        placeholder="Select date of birth"
        dateContainerStyle={width > 700 ? "w-50" : ""}
        error={errors.dateOfBirth}
      />

      {watchUnder18 && (
        <>
          <Form.Group>
            <Form.Field className="flex-row">
              <Icon color="red" name="warning sign" />
              <label className="my-0 pb-1 warning-text white">
                Person is under 18, please confirm below or change the date of
                birth.
              </label>
            </Form.Field>
          </Form.Group>

          <CheckboxComponent
            control={control}
            name="under18Confirm"
            label="Confirm the following:"
            error={errors.under18Confirm}
            fieldStyle="flex-row-center m-0"
          />
          <Form.Group className="pt-1">
            <Form.Field>
              {under18List.map((item) => (
                <label className="my-0 ml-2" key={item.value}>
                  {item.text}
                </label>
              ))}
            </Form.Field>
          </Form.Group>
        </>
      )}

      {!watchUnder18 && !isDesktop && !isInReadMode && (
        <>
          <CheckboxComponent
            control={control}
            name="confirmation"
            label="Please tick to confirm you have checked the following:"
            error={errors.confirmation}
            fieldStyle="flex-row-center m-0"
          />
          <Form.Group className="pt-1">
            <Form.Field>
              {confirmationList.map((item) => (
                <label className="my-0 ml-2" key={item.value}>
                  {item.text}
                </label>
              ))}
            </Form.Field>
          </Form.Group>
        </>
      )}
    </>
  );
};
export default CustomerHasIdForm;
